import { styled } from '~ui-kit/styled-components';

export const DialogSubtitle = styled.div`
  font-size: 12px;
  font-family: ${(props) => props.theme.fontFamily.montserrat};
`;
